import { useMutation } from "@tanstack/react-query";
import {
  replaceBookingsRange,
  ReplaceBookingsRangePayload,
  ReplaceBookingsRangeResponse
} from "PFApp/booking/services/api";
import { MutationOptions } from "PFTypes";

import { useProfileInvalidate } from "../profile";
import { bookingMutationsKeys } from "./mutation_keys";

export const useBookingsReplaceRange = (
  options: MutationOptions<ReplaceBookingsRangePayload, ReplaceBookingsRangeResponse>
) => {
  const { invalidateProfile } = useProfileInvalidate();
  const mutation = useMutation<ReplaceBookingsRangeResponse, unknown, ReplaceBookingsRangePayload>({
    mutationKey: bookingMutationsKeys.replaceRange(),
    mutationFn: replaceBookingsRange,
    ...options,
    onSuccess: (...args) => {
      const { filters } = args[1];
      invalidateProfile(filters.profileId);
      options.onSuccess?.(...args);
    }
  });

  return {
    mutation,
    replaceRange: mutation.mutateAsync
  };
};
